export const adminProjectsMessagesEn = {
  'adminProjects.header.title': 'Projects',
  'adminProjects.header.createProject.button': 'Create project',
  'adminProjects.summary.totalProjects.title': 'Total projects',
  'adminProjects.summary.draftProjects.title': 'Draft',
  'adminProjects.summary.inProgressProjects.title': 'In progress',
  'adminProjects.summary.completedProjects.title': 'Completed',
  'adminProjects.summary.refStdReview.title': 'Reference standard review',
  'adminProjects.content.table.status.draft': 'Draft',
  'adminProjects.content.table.status.inprogress': 'In progress',
  'adminProjects.content.table.status.completed': 'Completed',
  'adminProjects.content.table.status.created': 'Created',
  'adminProjects.content.table.status.refstdreview': 'Reference standard review',
  'adminProjects.content.table.status.updateLoading': 'Updating status...',
  'adminProjects.actionsMenu.changeStatus': 'Change status',
  'adminProjects.actionsMenu.editProject': 'Edit Project',

  'adminProjects.projectDetails.breadcrumb.adminProjects': 'Projects',
  'adminProjects.projectDetails.stats.createdOn': 'Created on',
  'adminProjects.projectDetails.stats.startedOn': 'Started on',
  'adminProjects.projectDetails.stats.completedOn': 'Completed on',
  'adminProjects.projectDetails.tab.overview': 'Overview',
  'adminProjects.projectDetails.tab.allocation': 'Allocation',
  'adminProjects.projectDetails.editProject': 'Edit project',
  'adminProjects.projectDetails.cancel': 'Cancel',
  'adminProjects.projectDetails.saveChanges': 'Save changes',
  'adminProjects.projectDetails.saveChanges.loading': 'Saving...',
  'adminProjects.projectDetails.saveChanges.success': 'Project changes saved',
  'adminProjects.projectDetails.saveChanges.error': 'Failed to save changes. Please try again.',

  'adminProjects.reallocation.button': 'Reallocate encounters',
  'adminProjects.reallocation.modal.title': 'Reallocate encounters',
  'adminProjects.reallocation.step.selectBatch': 'Select batch',
  'adminProjects.reallocation.step.configure': 'Configure',
  'adminProjects.reallocation.step.review': 'Review',
  'adminProjects.reallocation.selectBatch.heading': 'Select batch(es)',
  'adminProjects.reallocation.batch.training': 'Training',
  'adminProjects.reallocation.batch.validation': 'Validation',
  'adminProjects.reallocation.batch.test': 'Test',
  'adminProjects.reallocation.batch.humanAssignments': '{count} human assignments',
  'adminProjects.reallocation.batch.pending': '{count} pending',
  'adminProjects.reallocation.batch.draft': '{count} draft',
  'adminProjects.reallocation.batch.finalized': '{count} finalized',
  'adminProjects.reallocation.selectBatch.footnote':
    "Only human encounters in 'Pending annotation' status can be reassigned.",
  'adminProjects.reallocation.cancel': 'Cancel',
  'adminProjects.reallocation.back': 'Back',
  'adminProjects.reallocation.next': 'Next',
  'adminProjects.reallocation.confirm': 'Confirm reallocation',

  'adminProjects.reallocation.configure.heading': 'Reassign encounters (per batch)',
  'adminProjects.reallocation.configure.eligible': '{count} encounters eligible for reassignment',
  'adminProjects.reallocation.configure.addReassignment': 'Add reassignment',
  'adminProjects.reallocation.configure.previewLabel': 'Current allocation preview',
  'adminProjects.reallocation.configure.aiFootnote':
    'AI Agent assignments are fixed and cannot be modified.',
  'adminProjects.reallocation.row.fromAnnotator': 'From annotator',
  'adminProjects.reallocation.row.toAnnotator': 'To annotator',
  'adminProjects.reallocation.row.clearFromAnnotator': 'Clear from annotator',
  'adminProjects.reallocation.row.clearToAnnotator': 'Clear to annotator',
  'adminProjects.reallocation.row.numberOfEncounters': 'Number of encounters',
  'adminProjects.reallocation.row.selectAnnotator': 'Select annotator',
  'adminProjects.reallocation.row.noAnnotators': 'No annotators available',
  'adminProjects.reallocation.row.maxPending': 'Max {count} pending encounters',
  'adminProjects.reallocation.row.movableInfo':
    "Only {movable} of {fromName}'s {pending} pending encounters can be re-allocated to {toName}.",
  'adminProjects.reallocation.row.movableInfoNone':
    "None of {fromName}'s {pending} pending encounters can be re-allocated to {toName}.",
  'adminProjects.reallocation.review.heading': 'Review reallocation',
  'adminProjects.reallocation.review.noMoves':
    'No reassignments configured. The allocation below is unchanged.',
  'adminProjects.reallocation.review.move': 'Move {count} encounters from {fromName} → {toName}',
  'adminProjects.reallocation.review.impactSummary': 'Allocation impact summary',
  'adminProjects.reallocation.review.footnote':
    'Only Pending annotation encounters are affected by reallocation. Draft and Finalized encounters remain unchanged.',
  'adminProjects.reallocation.review.warning':
    "Only encounters in 'Pending annotation' status will be affected. Draft and Finalized encounters will not change.",
  // TODO: cleanup with cp_reallocation_ordered_movable_count_fix ff
  'adminProjects.reallocation.confirmedToast':
    "Reallocation configured across {batches} batches. Click 'Save changes' to apply reallocation.",
  'adminProjects.reallocation.confirmedToastSingle':
    "Reallocation configured for {batches} batch. Click 'Save changes' to apply reallocation.",
  'adminProjects.reallocation.confirmedToast.legacy':
    'Reallocation confirmed across {batches} batches',
  'adminProjects.reallocation.confirmedToastSingle.legacy':
    'Reallocation confirmed for {batches} batch',
  'adminProjects.reallocation.preview.batch': 'Batch',
  'adminProjects.reallocation.preview.annotator': 'Annotator',
  'adminProjects.reallocation.preview.pendingBefore': 'Pending (Before)',
  'adminProjects.reallocation.preview.deltaPending': 'Δ Pending',
  'adminProjects.reallocation.preview.pendingAfter': 'Pending (After)',
  'adminProjects.reallocation.preview.draft': 'Draft',
  'adminProjects.reallocation.preview.finalized': 'Finalized',
  'adminProjects.reallocation.preview.totalBefore': 'Total (Before)',
  'adminProjects.reallocation.preview.totalAfter': 'Total (After)',

  'adminProjects.projectOverview.title': 'Overview',
  'adminProjects.projectOverview.reviewConceptAndAttributes.title':
    'Concept groups & required attributes',
  'adminProjects.projectOverview.reviewConceptAndAttributes.conceptCountSuffix': 'concept groups',
  'adminProjects.projectAllocation.saveButton': 'Save allocations',
  'adminProjects.projectAllocation.saveButton.loading': 'Saving allocations...',

  'adminProjects.projectOverview.alert.description':
    'Edits apply only to encounters not yet annotated.',
  'adminProjects.overview.projectBasics.card.projectName': 'Project name',
  'adminProjects.overview.projectBasics.card.conditionArea': 'Condition area',
  'adminProjects.overview.projectBasics.card.healthSystem': 'Research partner',
  'adminProjects.overview.datasetSummary.title': 'Dataset summary',
  'adminProjects.overview.datasetSummary.totalEncounters': 'Total encounters',
  'adminProjects.overview.datasetSummary.validationEncounters': 'Validation encounters',
  'adminProjects.overview.datasetSummary.trainingEncounters': 'Training encounters',
  'adminProjects.overview.datasetSummary.testEncounters': 'Test encounters',
  'adminProjects.overview.allocationSummary.title': 'Allocation summary',
  'adminProjects.overview.allocationSummary.trainingAllocation': 'Training ({count} encounters)',
  'adminProjects.overview.allocationSummary.testAllocation': 'Test ({count} encounters)',
  'adminProjects.overview.allocationSummary.validationAllocation':
    'Validation ({count} encounters)',
  'adminProjects.overview.allocationSummary.totalEncounters': 'Total encounters',

  'adminProjects.allocation.selectAnnotators.title': 'Select annotators',
  'adminProjects.allocation.selectAnnotators.placeholder': 'Select annotators',
  'adminProjects.autocomplete.selected': 'Selected',
  'adminProjects.allocation.selectSupervisors.title': 'Select supervisors',
  'adminProjects.allocation.selectSupervisors.placeholder': 'Select supervisors',
  'adminProjects.allocation.allocationMode.title': 'Allocation mode',
  'adminProjects.allocation.allocationMode.defaultAllocation': 'Default allocation',
  'adminProjects.allocation.allocationMode.customAllocation': 'Custom allocation',
  'adminProjects.allocation.allocationConfiguration.defaultAllocationMode.description':
    'Default allocation mode will distribute the total number of encounters equally among all annotators.',
  'adminProjects.allocation.allocationConfiguration.trainingAllocation':
    'Training ({count} encounters)',
  'adminProjects.allocation.allocationConfiguration.testAllocation': 'Test ({count} encounters)',
  'adminProjects.allocation.allocationConfiguration.validationAllocation':
    'Validation ({count} encounters)',
  'adminProjects.allocation.allocationConfiguration.totalEncounters': 'Total encounters',
  'adminProjects.allocation.allocationConfiguration.totalEncounters.description':
    'Total number of encounters to be distributed among annotators.',
  'adminProjects.allocation.allocationConfiguration.totalMustBe100Percent':
    'Percentages must add up to 100%',
  'adminProjects.allocation.allocationConfiguration.selectAnnotator':
    'Please select at least one annotator',
};
